import { getSheetLink } from '@livv/utils/helpers';
import { query, where, getDocs } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { codeArticlesCollection } from '@utils/collections';
import { getLegifranceLink } from '@utils/legifrance';

// eslint-disable-next-line import/prefer-default-export
export const useArticleLink = (
    versionId: string,
    textTitle: string,
    isInFirestore?: boolean,
): { articleId: string; link: string } => {
    const [link, setLink] = useState('');
    const [articleId, setArticleId] = useState('');

    useEffect(() => {
        const fetchArticle = async (): Promise<string | null> => {
            const articles = await getDocs(
                query(codeArticlesCollection, where('versionsIds', 'array-contains', versionId)),
            );

            if (articles.empty) {
                return null;
            }

            if (articles.size > 1) {
                throw new Error(`multiple article documents found for versionId ${versionId}`);
            }

            const article = articles.docs[0];
            setArticleId(article.id);
            const articleData = article.data();
            const { keyword } = articleData;

            return getSheetLink({
                bookId: keyword.treeId,
                bookPath: keyword.path.join('/'),
                sheetId: article.id,
            });
        };

        // case when parsing html and we only have the articleId
        if (isInFirestore === undefined || isInFirestore) {
            // .then to avoid the type issue with root lvl async/await in useEffect
            fetchArticle().then((articleUrl) => {
                setLink(articleUrl || getLegifranceLink(versionId));
            });
        } else {
            setLink(getLegifranceLink(versionId));
        }
    }, [versionId, isInFirestore, link, textTitle]);

    return { articleId, link };
};
